import { jsx as _jsx } from "react/jsx-runtime";
import { PermissionDenied } from '#components/PermissionDenied';
import { useAuth } from '#contexts/AuthContext';
import { Loader, Log } from '@swyft/core';
import React from 'react';
export const PrivateRoute = ({ children, permission }) => {
    const { hasPermission, isAuthenticated, isLoading, signInRedirect } = useAuth();
    React.useEffect(() => {
        if (isAuthenticated || isLoading) {
            return;
        }
        Log.info('PrivateRoute : SignInSilentError => Redirect');
        signInRedirect();
    }, [isAuthenticated, isLoading, signInRedirect]);
    if (isLoading) {
        Log.debug('PrivateRoute', 'No auth state / loading:', isLoading);
        return _jsx(Loader, {});
    }
    if (!hasPermission(permission)) {
        Log.info('PrivateRoute:PermissionDenied');
        return _jsx(PermissionDenied, {});
    }
    return children ?? null;
};
